import React, { useEffect, useContext } from 'react';
import { Link } from 'react-router-dom';
import { Col, Row, Table, DropdownItem } from 'reactstrap';

import Icon from '@/components/common/icon';
import { Input } from '@/components/form';
import ResourceListAdmin from '@/components/resources/list';
import ResourceListManager from '@/components/resources/listAdmin';
import View from '@/components/view';
import Context from '@/services/context';
import security from '@/services/security';
import { t } from '@/services/translator';

export default () => {
  const { eligibility } = useContext(Context);
  const isManager = !security.isGranted('ROLE_ADMIN') && !security.isGranted('ROLE_SUPER_ADMIN');
  const ResourceList = isManager ? ResourceListManager : ResourceListAdmin;

  useEffect(() => {}, [eligibility]);

  const redirectAction = (item) => {
    if (isManager) {
      return null;
    }

    return (
      <DropdownItem>
        <Link to={`/eligibility/editor?id=${item.id}`}>
          <Icon name="directions" className="iconRightMarginMax" /> {t('editor')}
        </Link>
      </DropdownItem>
    );
  };

  return (
    <View>
      <ResourceList
        resource="EligibilityRule"
        admin={security.isGranted('ROLE_ADMIN')}
        extraParameters={eligibility}
        deleteMultiple
        filters={() => (
          <Row>
            <Col lg={3}>
              <Input name="alias" />
            </Col>
          </Row>
        )}
        body={({ collection, renderColumn, renderItemActions, renderSelect }) => (
          <Table responsive hover>
            <thead className="thead-light">
              <tr>
                {renderColumn(renderSelect('*'), false)}
                {renderColumn('id')}
                {renderColumn('alias')}
                {renderColumn()}
              </tr>
            </thead>
            <tbody>
              {collection.map((item) => (
                <tr key={item.id}>
                  <td>{renderSelect(item.id)}</td>
                  <td>{item.id}</td>
                  <td>{item.alias}</td>
                  <td>{!isManager && renderItemActions(item, redirectAction(item))}</td>
                </tr>
              ))}
            </tbody>
          </Table>
        )}
      />
    </View>
  );
};
